export default {
  ERROR_UNEXPECTED: 'ERROR_UNEXPECTED',
  ERROR_TOOLBAR_ITEM_DEFINITION: 'ERROR_TOOLBAR_ITEM_DEFINITION',
  ERROR_TOOLBAR_ITEM_NOT_FOUND: 'ERROR_TOOLBAR_ITEM_NOT_FOUND',
  ERROR_INVALID_PARAMETERS: 'ERROR_INVALID_PARAMETERS',
  ERROR_WRAPPER_OPERATION_FAILED: 'ERROR_WRAPPER_OPERATION_FAILED'
}
